import { Action } from "@ngrx/store";

export const actionTypes: any = {
    SHOW_LOADING: "Show loading",
    HIDE_LOADING: "Hide Loading",
    SURPRESS_LOADING: "Surpress Loading",
    UNSURPRESS_LOADING: "Unsurpress Loading"
};

export class ShowLoadingAction implements Action {
    type = actionTypes.SHOW_LOADING;
}

export class HideLoadingAction implements Action {
    type = actionTypes.HIDE_LOADING;
}

export class SurpressLoadingAction implements Action {
    type = actionTypes.SURPRESS_LOADING;
}

export class UnsurpressLoadingAction implements Action {
    type = actionTypes.UNSURPRESS_LOADING;
}


export type Actions = ShowLoadingAction
    | HideLoadingAction | SurpressLoadingAction | UnsurpressLoadingAction ;